import Icon from '@components/common/Icon';

const ProjectsSection = () => {
  return (
    <section
      className="py-20 px-4 sm:px-6 lg:px-8"
      style={{
        backgroundColor: 'var(--color-theme-2)',
      }}
    >
      <div className="container mx-auto max-w-7xl">
        {/* Section Header */}
        <div className="text-center mb-12 space-y-4">
          <div className="flex items-center justify-center gap-3 mb-4">
            <Icon name="music" size="xl" style={{ color: 'var(--color-accent-6)' }} />
            <h2
              className="text-4xl sm:text-5xl font-heading font-bold tracking-tight"
              style={{ color: 'var(--color-heading)' }}
            >
              Projects
            </h2>
          </div>
          <p
            className="text-lg max-w-3xl mx-auto"
            style={{ color: 'var(--color-subtle)' }}
          >
            YouTube channel featuring diverse interests and creative content
          </p>
        </div>

        {/* Project Card */}
        <div className="max-w-4xl mx-auto">
          <div
            className="rounded-2xl overflow-hidden shadow-card transition-all duration-300 hover:shadow-card-hover"
            style={{
              backgroundColor: 'var(--color-card-bg)',
              borderColor: 'var(--color-card-border)',
              borderWidth: '1px',
              borderStyle: 'solid',
            }}
          >
            <div className="p-8 space-y-6">
              {/* Project Title */}
              <div className="flex items-start gap-4">
                <div
                  className="w-16 h-16 rounded-full flex items-center justify-center flex-shrink-0"
                  style={{
                    backgroundColor: 'var(--color-accent-2)',
                  }}
                >
                  <svg
                    className="w-8 h-8"
                    style={{ color: 'var(--color-accent-7)' }}
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                  </svg>
                </div>
                <div className="flex-1">
                  <h3
                    className="text-2xl sm:text-3xl font-bold mb-2"
                    style={{ color: 'var(--color-heading)' }}
                  >
                    Brownian Motion
                  </h3>
                  <div
                    className="inline-block px-3 py-1 rounded-full text-sm font-semibold"
                    style={{
                      backgroundColor: 'var(--color-accent-2)',
                      color: 'var(--color-accent-7)',
                    }}
                  >
                    YouTube Channel
                  </div>
                </div>
              </div>

              {/* Project Description */}
              <p
                className="text-lg leading-relaxed"
                style={{ color: 'var(--color-subtle)' }}
              >
                Random videos covering my interests including mathematics, programming, Arduino, chess, and music. Will post regularly from 2026.
              </p>

              {/* Topics Grid */}
              <div className="pt-4">
                <h4
                  className="text-sm font-semibold mb-3"
                  style={{ color: 'var(--color-muted)' }}
                >
                  Content Topics:
                </h4>
                <div className="flex flex-wrap gap-2">
                  {['Mathematics', 'Programming', 'Arduino', 'Chess', 'Music'].map((topic) => (
                    <span
                      key={topic}
                      className="px-3 py-1 rounded-full text-sm"
                      style={{
                        backgroundColor: 'var(--color-theme-3)',
                        color: 'var(--color-body-text)',
                      }}
                    >
                      {topic}
                    </span>
                  ))}
                </div>
              </div>

              {/* Timeline */}
              <div
                className="pt-6 border-t flex items-center gap-2"
                style={{ borderColor: 'var(--color-border-light)' }}
              >
                <svg
                  className="w-5 h-5"
                  style={{ color: 'var(--color-muted)' }}
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M6 2a1 1 0 000 2h8a1 1 0 100-2H6zM4 5a2 2 0 012-2h8a2 2 0 012 2v10a2 2 0 01-2 2H6a2 2 0 01-2-2V5z" />
                </svg>
                <span
                  className="text-sm font-semibold"
                  style={{ color: 'var(--color-muted)' }}
                >
                  Regular posting starting 2026
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
